import React from "react";
import { FormFrame } from "@/components/common/FormFrame";

// Canada intake form (public/canada-form.html), shown under the site header.
export const CanadaApplyPage = () => <FormFrame src="/canada-form.html" title="Canada application form" testid="canada-apply-page" />;

export default CanadaApplyPage;
